<script>
import Multiselect from "vue-multiselect";

export default {
    name: 'AtendimentosRealizados',
    components: {Multiselect},
    props: {
        listProfessionals: { type: Array, default: () => [] },
        listPacients: { type: Array, default: () => [] },
        listSpecialties: { type: Array, default: () => [] },
        currentParams: { type: Object }
    },
    computed: {
        specialtyOptions() {
            const specialties = this.selectedProfessionals.length
                ? this.selectedProfessionals.reduce((items, professional) => {
                    return items.concat(professional.specialty || professional.specialties || [])
                }, [])
                : this.listSpecialties

            const uniqueSpecialties = specialties.reduce((items, specialty) => {
                if (specialty && specialty.id && !items.some((item) => item.id === specialty.id)) {
                    items.push(specialty)
                }

                return items
            }, [])

            return [
                { id: null, name: "Todos" },
                ...uniqueSpecialties
            ]
        },
        selectedProfessionals() {
            const professionals = Array.isArray(this.currentParams.professionals) ? this.currentParams.professionals : []

            return professionals.map((professional) => {
                return this.listProfessionals.find((item) => item.id === professional.id) || professional
            })
        },
    },
    watch: {
        selectedProfessionals() {
            this.currentParams.specialty = null
        },
        specialtyOptions(options) {
            const selectedSpecialty = this.currentParams.specialty
            if (selectedSpecialty && !options.some((option) => option.id === selectedSpecialty.id)) {
                this.currentParams.specialty = null
            }
        },
    },
    created() {
        if (!Object.prototype.hasOwnProperty.call(this.currentParams, "specialty")) {
            this.$set(this.currentParams, "specialty", null)
        }
    },
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">Preencha os campos abaixo para filtrar:</div>
      <form class="form-filter-report mt-3">
        <div class="row">
          <div class="col-md-6">
            <label for="date-ini">De:</label>
            <input type="date" name="date-ini" id="date-ini" class="form-control" placeholder="Data inicial" v-model="currentParams.date_ini">
          </div>
          <div class="col-md-6">
            <label for="date-end">Até:</label>
            <input type="date" name="date-end" id="date-end" class="form-control" placeholder="Data final" v-model="currentParams.date_end">
          </div>
        </div>
        <div v-if="listProfessionals.length > 0" class="row">
          <div class="col-md-12">
            <label for="professional">Profissional:</label>
            <Multiselect
             id="professional"
             :options="listProfessionals"
             :multiple="true"
             v-model="currentParams.professionals"
             label="name"
             track-by="id"
             deselect-label="ENTER para remover"
             select-label="Enter para selecionar"
             placeholder="Selecione"
            >
            </Multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="specialty" class="text-left">Tipo de Atendimento:</label>
            <Multiselect
             id="specialty"
             :options="specialtyOptions"
             :multiple="false"
             v-model="currentParams.specialty"
             label="name"
             track-by="id"
             deselect-label="ENTER para remover"
             select-label="Enter para selecionar"
             placeholder="Todos"
            >
            </Multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="pacient" class="text-left">Paciente:</label>
            <Multiselect 
             id="pacient"
             :options="listPacients"
             :multiple="true"
             v-model="currentParams.pacients"
             label="nome"
             track-by="id"
             deselect-label="ENTER para remover"
             select-label="Enter para selecionar"
             placeholder="Selecione"
            >
            </Multiselect>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
